import { MessagesActions } from './';
import { Validation } from '../helper';

export class ValidationActions {
    static fileSize(size, limit) {
        return (dispatch) => {
            if(Validation.fileSize(size, limit)) return true;
            
            dispatch(MessagesActions.pushError(`לא ניתן להעלות קובץ הגדול מ-${limit/1000000}mb`));
            
            return false;
        }
    }

    static fileType(type, limit) {
        return (dispatch) => {
            if(Validation.imageFileType(type, limit)) return true;

            dispatch(MessagesActions.pushError(`הקובץ יכול להיות מסוג ${limit.join(', ')} בלבד`));

            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/validation.js